import React from "react";
import PassedOutReports from "../shared/reports/PassedOutReports";

function ControllerPassedOutReportsPage({ students }) {
  return <PassedOutReports students={students} />;
}

export default ControllerPassedOutReportsPage;
